import * as THREE from 'three'
import Experience from '../../Experience'

export default class Flower {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.time = this.experience.time
        this.ui = this.experience.debug.ui
        this.targetPos = _options.targetPos
        this.materials = _options.materials

        // 
        this.setMesh()
        // this.setDebug()
    }

    setMesh() {
        this.group = new THREE.Group()
        this.geometry = new THREE.SphereGeometry(0.2, 20, 20)
        this.redMat = this.materials.redMat.clone()
        this.blackMat = this.materials.blackMat.clone()
        // modifier les vertex shader en fonction de la fleur que l'on créer
        this.setTige()
        this.setCenter()
        this.setPetals()
        // 
        this.scene.add(this.group)
        // Ajout du BoxHelper autour du groupe
        this.boxHelper = new THREE.BoxHelper(this.group, 0xffff00) // Couleur jaune par défaut
        this.scene.add(this.boxHelper)
    }

    setTige() {
        this.tigeGeo = new THREE.CylinderGeometry(0.01, 0.02, 0.5, 12, 12)
        this.tigeMat = this.blackMat
        this.tige = new THREE.Mesh(this.tigeGeo, this.tigeMat)
        this.tige.position.y = 0.25
        this.group.add(this.tige)
    }
    setCenter() {
        this.centerGeo = new THREE.SphereGeometry(0.1, 20, 20)
        this.centerMat = this.redMat
        this.center = new THREE.Mesh(this.centerGeo, this.centerMat)
        this.center.position.y = 0.5
        this.center.scale.x = 0.5
        this.group.add(this.center)
    }
    setPetals() {
        this.petalGeo = new THREE.SphereGeometry(0.03, 10, 10)
        this.petalMat = this.redMat
        this.petals = []

        const petalCount = 8
        for (let i = 0; i < petalCount; i++) {
            this.petals.push(new THREE.Mesh(this.petalGeo, this.petalMat))
        }

        const rotationCenter = this.center.position
        this.petals.forEach((petal, i) => {

            petal.position.copy(rotationCenter)
            petal.position.z += Math.cos(this.time.elapsed * 0.001 + i / petalCount) * 0.2
            petal.position.y += Math.sin(this.time.elapsed * 0.001 + i / petalCount) * 0.2

            this.group.add(petal)
        })

        // this.group.add(this.center)
    }


    destroy() {



    }

    setDebug() {

    }
    update() {
        this.group.position.set(this.targetPos.x, this.targetPos.y, this.targetPos.z)
        // const scale = Math.abs(Math.cos(this.time.elapsed * 0.001))
        const scale = 2
        this.group.rotation.y = Math.cos(this.time.elapsed * 0.001)
        this.group.scale.set(scale, scale, scale)
        const count = this.petals.length;
        const radius = 0.15;
        const speed = 0.001;
        const angleOffset = this.time.elapsed * speed;

        this.petals.forEach((petal, i) => {
            const angle = (i / count) * Math.PI * 2 + angleOffset;

            // Position circulaire
            petal.position.copy(this.center.position);
            petal.position.z += Math.cos(angle) * radius;
            petal.position.y += Math.sin(angle) * radius;

            // Scale variant entre 0 et 1
            let scale = (Math.sin((angle + 0.8)) + 1) / 2; // map [-1, 1] to [0, 1]
            scale = Math.pow(scale * 1.2, 2)
            petal.scale.set(scale, scale, scale); // équivalent à set(scale, scale, scale)
        });


        this.boxHelper.update()
    }

}